module.exports = __webpack_public_path__ + "img/user-nav-jrcz-icon.3aa7dd84.png";